import React, { useMemo } from 'react';
import { flex } from '@fabric-ui/theme';
import { ellipsis } from '@fabric-ui/utils';
import { Box, Divider } from '@mui/material';

const DetailsCardCloseInfo = ({ titlesAndValues }: { titlesAndValues: { title: string; value: string }[] }) => {
  const titlesAndValuesFiltered = useMemo(() => titlesAndValues.filter(({ value }) => value, []), [titlesAndValues]);

  return (
    <Box sx={{ ...flex.center, gap: 2, overflow: 'hidden', flexWrap: 'nowrap', ml: 2 }} aria-label="details container">
      {titlesAndValuesFiltered.map(({ title, value }, index) => (
        <Box key={title} sx={{ ...flex.row, gap: 2, overflow: 'hidden' }}>
          {index > 0 && <Divider orientation="vertical" flexItem sx={{ height: 20, mt: '3px' }} />}
          <Box sx={{ ...flex.itemsCenter, gap: 1, flexGrow: 1, flexShrink: 1, overflow: 'hidden' }}>
            <Box
              sx={{ fontWeight: 600, color: theme => theme.palette.colors.neutrals[500], flexShrink: 0, ...ellipsis }}
              aria-label={title}>
              {title}:
            </Box>
            <Box sx={{ ...ellipsis, flexGrow: 1, minWidth: '150px' }} aria-label={value}>
              {value}
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
export { DetailsCardCloseInfo };
